import * as React from 'react';
import * as EDTools from '../utils/EDTools';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { useEffect, useState } from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { Popup } from "@progress/kendo-react-popup";
import { ArcGauge } from '@progress/kendo-react-gauges';
import { useLocation } from 'react-router-dom';
import { useGlobalState } from '../App.js';
import CallInIcon from "./..//assets/comm-icons/call-in.svg";
import { StackLayout } from "@progress/kendo-react-layout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faCalendarCheck, faChartLine, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Chart, ChartTitle, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartLegend, ChartCategoryAxisTitle, ChartCategoryAxisItem } from '@progress/kendo-react-charts';
import { Card, CardHeader, CardTitle, CardBody, CardActions, CardImage, CardSubtitle, Avatar } from '@progress/kendo-react-layout';

const colors = [
    {
        color: '#0058e9',
    },
];


var agentMap = EDTools.EDMakeAgentMap();
var vQueueMap = EDTools.EDMakeQueueMap(); 
 

const dbOptions = {
    StatusReadyColor: '#37B400',
    StatusNotReadyColor: '#FF6358',
    StatusWrapupColor: '#ADD8E6',
    StatusBusyColor: '#FFC000',
    StatusPresenceProfileColor: '#CC8899',
    StatusLoggedOutColor: '#C0C0C0',
    AgentsShowLoggedOutAll: false,
    AgentsShowLoggedOutActiveCurrentDay: true,
    Timezone: 'America/Chicago',
    AgentAvatarFormat: 'FirstName LastName'
};
// Field Service

const configuredVQueues = [
    {
        vQueueId: "f8d48375-892d-46cd-b107-ca072dfc66ed",
        position: 0,
        name: "Field Service",
        footerText: "Calls in Queue",
        realQueueList: ["9B730DB4267C4B1AABE81933FD3B599B"],
        icon: "call",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "3b32adec-2e90-4790-9f3a-84ceb9243926",
        position: 1,
        name: "Distributers",
        footerText: "Calls in Queue",
        realQueueList: ["80AA0FBD79F548B1A03A7927726DD54E"],
        icon: "call",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "fce86769-5930-4a34-a501-19e599695868",
        position: 3,
        name: "FM II",
        footerText: "Calls in Queue",
        realQueueList: ["59A62944A96841399C37ECF0DE295E11"],
        icon: "call",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "971f2eb5-432b-470f-86d4-dd8d3f6478f1",
        position: 4,
        name: "Recall",
        footerText: "Calls in Queue",
        realQueueList: ["63A67F1CAC304D959AA2ABA1DC506900"],
        icon: "call",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "29011b0a-240e-40a9-8e4f-1f9137b40b89",
        position: 5,
        name: "FM II Recall",
        footerText: "Calls in Queue",
        realQueueList: ["8E96234055BC48C89DA9D2D94B3F7A85"],
        icon: "call",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "19ccb2d9-6751-400c-964f-c7ac7d297bf2",
        position: 6,
        name: "Warranty TS",
        footerText: "Calls in Queue",
        realQueueList: ["C691B6B29A294CF295581E1B82ACCC3A"],
        icon: "call",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "af359224-7bfa-4444-9084-5e1f6ef057a2",
        position: 7,
        name: "TS E-mail",
        footerText: "Emails in Queue",
        realQueueList: ["FBF7F3A245F8426E8DC70CB09EEDEF06"],
        icon: "email",
        alertLongestWaitInSeconds: 20,
    },
    {
        vQueueId: "9d86203c-f322-44c1-b0e0-4d8f2be0f415",
        position: 8,
        name: "CS E-mail",
        footerText: "Emails in Queue",
        realQueueList: ["007EB151DDA9415E995C070F06053AD8"],
        icon: "email",
        alertLongestWaitInSeconds: 20,
    }
];



export const FMDashboardQueues = () => {
    const [loginInfo, updateLoginInfo] = useGlobalState();

    const [layout, setLayout] = React.useState("stretched");
    const waitAnchor = [React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null)]; 
    const [showCallsDuration, setShowCallsDuration] = React.useState(true);
    const emailsDurationAnchor = React.useRef(null);
    const [showEmailsDuration, setShowEmailsDuration] = React.useState(true);
    const [queueLData, setQueueLData] = React.useState(new Map());
    const [agentLData, setAgentLData] = React.useState(new Map());
    const [agentLDataSorted, setAgentLDataSorted] = React.useState([]);
    const [callHistoryData, setCallHistoryData] = React.useState(EDTools.EDMakeEmptyContactHistory());
    const [emailHistoryData, setEmailHistoryData] = React.useState(EDTools.EDMakeEmptyContactHistory());
    const [dashboardData, setDashboardData] = React.useState({
        "numMessagesActive": 0,
        "totalNumMessages": 0,
        "numRoutesActive": 0,
        "totalNumRoutes": 0,
        "activeRouteDetails": "No Active Route Defined",
        "numCustomMessagesActive": 0,
        "totalNumCustomMessages": 0,
        "messages": {},
        "routes": {}
    });
    const [queueTiles, setQueueTiles] = React.useState([]);

    const [connection, setConnection] = React.useState();
    const [isConfigured, setConfigured] = React.useState(false);

    const dashboardId = "42cbbc39-2874-4993-ba47-689ac029c49c";

    useEffect(() => {
        setQueueTiles(createVQueueTiles(vQueueMap, configuredVQueues));
         const connect = new HubConnectionBuilder()
            .withUrl("https://eyedogzsloan.covington.io/dashboard")
            .configureLogging(LogLevel.Information)
            .withAutomaticReconnect()
            .build();

        setConnection(connect);
    }, []);

    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {
                    connection.on("initiated", (Message) => {
                        console.log(Message);
                    });
                    connection.on("updateStats", (Message, index) => {
                        console.log(Message + ', index: ' + index);
                    });
                    connection.on("statusUpdate", (Message) => {
                        console.log("statusUpdate RECEIVED");
                        console.log(Message);
                    //    agentMap = EDTools.EDVAgentZeroData(agentMap);
                    //    console.log("statusUpdate. Agent Map before:")
                    //    console.log(agentMap);
                    //    agentMap = EDTools.EDProcessAgentUserStatistics(agentMap, Message.userStatistic);
                    //    agentMap = EDTools.EDProcessAgentUserStatus(agentMap, Message.userStatus);
                    //    agentMap = EDTools.EDProcessAgentUserStatisticsDay(agentMap, Message.userStatisticDay);
                    //    console.log("agent map after");
                   //     console.log(agentMap);
                        vQueueMap = EDTools.EDVQueueZeroData(vQueueMap);
                        console.log("vqueue map after zeroing");
                        for (let [key, value] of vQueueMap) {
                            console.log(key + " = " + JSON.stringify(value));
                        }
                        vQueueMap = EDTools.EDProcessQueueStatusV(vQueueMap, Message.queueStatus);
                        vQueueMap = EDTools.EDProcessQueueStatisticV(vQueueMap, Message.queueStatistic);

                        console.log("vqueue map after update for vqueues");
                        for (let [key, value] of vQueueMap) {
                            console.log(key + " = " + JSON.stringify(value));
                        }
                        setQueueLData(vQueueMap);
                        setQueueTiles(createVQueueTiles(vQueueMap, configuredVQueues));
                    //    var sortedAgents = EDTools.EDGetSortedArray(Array.from(agentMap.values()));
                   //     setAgentLData(agentMap);
                   //     setAgentLDataSorted(sortedAgents);

                    //    var contactHistories = EDTools.EDProcessContactHistory(Message.contactHistory);
                    //    console.log("contactHistories map after update for histories");
                    //    for (let [key, value] of contactHistories) {
                    //        console.log(key + " = " + JSON.stringify(value));
                    //    }
                      //  var phoneHistories = EDTools.EDMakeContactHistoryArray(contactHistories, '8BE8B37D8A0A45CA8CAAE8EDC29439E4');
                      //  var emailHistories = EDTools.EDMakeContactHistoryArray(contactHistories, 'D576F0F51C204CADA6AB55ACEB3C6D95');
                      //  setCallHistoryData(phoneHistories);
                      ///  setEmailHistoryData(emailHistories);
                    });
                    connection.on("configUpdate", (Message) => {
                        console.log("configUpdate RECEIVED");
                        console.log(Message);
                        configureDashboard(Message);
                    })

                    var validConnId = connection?.invoke("LoadDbConfig", dashboardId);

                    var connectionId = connection?.invoke("SubscribeForData", dashboardId);
                    console.log("SubscribeForData returns: " + connectionId);
                }).catch((error) => console.log(error));
        }

    }, [connection]);

    const configureDashboard = (config) => {
        console.log("configureDashboard [Begin]");
        console.log(agentMap);
        var idx = 0;
        if (config.userSubs === null) {
            EDTools.EDLog("userSubs is null");
        }
        else if (config.userSubs.length === 0) {
            EDTools.EDLog("userSubs is empty");
        }
        else {
            for (idx = 0; idx < config.userSubs.length; idx++) {
                var currUser = config.userSubs[idx];
                agentMap = EDTools.EDSubscribeAgent(agentMap, currUser.esUserId, currUser);
                console.log("subscribe: " + currUser.esUserId);
                console.log(agentMap);
            }
        }
        if (config.virtualQueueSubs === null) {
            EDTools.EDLog("virtualQueueSubs is null");
        }
        else if (config.virtualQueueSubs.length === 0) {
            EDTools.EDLog("virtualQueueSubs is empty");
        }
        else {
            for (idx = 0; idx < config.virtualQueueSubs.length; idx++) {
                var currVQueue = config.virtualQueueSubs[idx];
                vQueueMap = EDTools.EDSubscribeVQueue(vQueueMap, currVQueue.edDashoardVirtualQueueId, currVQueue);
                console.log("subscribe vQueue: " + currVQueue.edDashoardVirtualQueueId + " Contains:");
                for (let [key, value] of vQueueMap) {
                    console.log(key + " = " + JSON.stringify(value));
                }
            }
        }

        setQueueLData(vQueueMap);
        setAgentLData(agentMap);
        setAgentLDataSorted(Array.from(agentMap.values()));


        setConfigured(true);
        console.log("configureDashboard. Agent Map:");
        console.log(agentMap);
        console.log("configureDashboard [End]");
    }

    const handleReposition = (e) => {
        setData(e.value);
    };

    useEffect(() => {
        loadState();
    }, []);

    const loadState = () => {


    }

    const [data, setData] = React.useState([
        {
            col: 1,
            colSpan: 3,
            rowSpan: 2,
        },
        {
            col: 1,
            colSpan: 2,
            rowSpan: 3,
        },
    ]);

    const [callsPerHour, emailsPerHour] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
    const hours = ['5 am', '6 am', '7 am', '8 am', '9 am', '10 am', '11 am', '12 pm', '1 pm', '2 pm', '3 pm', '4 pm', '5 pm', '6 pm'];

    const agentStatus = [{
        category: 'Ready',
        value: 2,
        color: '#37B400'
    }, {
        category: 'Not Ready',
        value: 4,
        color: '#FF6358'
    }, {
        category: 'Busy',
        value: 3,
        color: '#FFC000'
    }, {
        category: 'Wrap-up',
        value: 1,
        color: 'LightBlue'
    }];


    const labelContent = props => {
        if (props.dataItem.value !== 0)
            return `${props.dataItem.value}`;
        else
            return '';
    };


    const createVQueueTiles = (vQueueMap, vQueues) => {
        var retCard = [];
        var idx = 0;
       
        for (idx = 0; idx < vQueues.length; idx++) {
            retCard.push(createVQueueTile(vQueueMap, vQueues[idx], idx));
        }
        return retCard;
    }

    const createVQueueTile = (queueLData, vQueue, idx) => {
        return {
            defaultPosition: {
                col: idx + 1,
                colSpan: 1,
                rowSpan: 2,
            },
            header: <span class="k-card-title top-align-edz"><span class="material-symbols-outlined top-align-edz">{configuredVQueues[idx].icon}</span >&nbsp;{configuredVQueues[idx].name}</span>,
            body: <div className="dashboard-card-content">
                <p className="dashboard-card-content-number green">{EDTools.EDQueueGetNumInQueue(queueLData, configuredVQueues[idx].vQueueId)}<span ref={waitAnchor[idx]}></span>
                    <Popup anchor={waitAnchor[idx].current} show={(EDTools.EDQueueGetNumInQueue(queueLData, configuredVQueues[idx].vQueueId) === 0) ? false : true} anchorAlign={{
                        horizontal: "right",
                        vertical: "middle",
                    }} popupAlign={{
                        horizontal: "left",
                        vertical: "top",
                    }} popupClass={(EDTools.EDQueueGetLongestWaitTimeInQueueSeconds(queueLData, configuredVQueues[idx].vQueueId) > 20) ? 'queue-callwaiting-alert' : 'queue-callwaiting'} >
                        {EDTools.EDQueueGetLongestWaitTimeInQueue(queueLData, configuredVQueues[idx].vQueueId)}
                    </Popup></p>

                <div>
                    <p className="footer">
                        {configuredVQueues[idx].footerText}
                    </p>
                </div>
                <Chart transitions={false}>
                    <ChartTitle text={`${EDTools.EDQueueGetNumAgentsLoggedIn(queueLData, configuredVQueues[idx].vQueueId)} Agents`} position="bottom" font="28px Roboto, Arial, sans-serif" />
                    <ChartLegend position="top" />
                    <ChartSeries>
                        <ChartSeriesItem type="pie" data={EDTools.EDQueueGetAgentsData(queueLData, configuredVQueues[idx].vQueueId, dbOptions)} field="value" categoryField="category" colorField="color" labels={{
                            visible: true,
                            content: labelContent,
                            position: 'center',
                            font: "bold 28px Arial, sans-serif"
                        }} />
                    </ChartSeries>
                </Chart>
                <div>
                    <p className="footer">
                        {EDTools.EDQueueGetNumContactsHandled(queueLData, configuredVQueues[idx].vQueueId)} Handled / {EDTools.EDQueueGetAvgHandleTime(queueLData, configuredVQueues[idx].vQueueId)} AHT
                    </p>
                    <p className="footer">
                        {EDTools.EDQueueGetAbandonmentRate(queueLData, configuredVQueues[idx].vQueueId)}% Abandon Rate
                    </p>
                </div>
            </div>,

        }
    }




    return (
        <div>
            <div className="DBHeader">
                <StackLayout orientation="horizontal" gap="0">
                    <div className="k-flex-40 DBHeaderTitle">
                        Queues
                    </div>
                    <div className="k-flex-10" />
                    <div className="k-flex-20" />
                    <div className="k-flex-30 right-align" >
                        <img className="DBHeaderLogo" alt="Sloan" src={require("./..//assets/flushmate-logo.png")} ></img>
                    </div>
                </StackLayout>
            </div>

            <TileLayout className="DBLayoutBG" columns={8} items={queueTiles} rows={3} />

        </div>

    );

    const fetchData = () => {

    }


};


